export default "__VITE_ASSET__CKlz84jR__"